import { ColorCell, HeaderCell, NoColorCell, TickerCell } from './components';

export default [
  {
    label: 'Ticker',
    dataKey: 'asset',
    cellRenderer: TickerCell,
    headerRenderer: HeaderCell,
  },
  {
    label: 'Base',
    dataKey: 'base',
    cellRenderer: NoColorCell,
    headerRenderer: HeaderCell,
  },

  {
    label: 'Last Price',
    dataKey: 'lastOrderPrice',
    cellRenderer: NoColorCell,
    headerRenderer: HeaderCell,
  },
  // {
  //   label: 'Base Volume 30 Min',
  //   dataKey: 'thirtyMinBaseValue',
  //   cellRenderer: NoColorCell,
  // headerRenderer: HeaderCell,
  // },
  {
    label: 'Base Volume Avg 30 Min',
    dataKey: 'thirtyMinBaseVolumeAvgChange',
    cellRenderer: ColorCell,
    headerRenderer: HeaderCell,
  },
  {
    label: 'Price Change 30 Min',
    dataKey: 'thirtyMinPriceChange',
    cellRenderer: ColorCell,
    headerRenderer: HeaderCell,
  },
  // {
  //   label: '30 Minute B:S',
  //   dataKey: 'thirtyMinBsRatio',
  //   cellRenderer: ColorCell,
  //   headerRenderer: HeaderCell,
  // },
  // {
  //   label: 'Price Change 5 Min',
  //   dataKey: 'fiveMinPriceChange',
  //   cellRenderer: ColorCell,
  //   headerRenderer: HeaderCell,
  // },
  // {
  //   label: '5 Minute B:S',
  //   dataKey: 'fiveMinBsRatio',
  //   cellRenderer: ColorCell,
  //   headerRenderer: HeaderCell,
  // },
  // {
  //   label: 'Price Change 24 Hr',
  //   dataKey: 'twentyFourHrPriceChange',
  //   cellRenderer: ColorCell,
  //   headerRenderer: HeaderCell,
  // },
  // {
  //   label: 'RSI',
  //   dataKey: 'rsi',
  //   cellRenderer: NoColorCell,
  //   headerRenderer: HeaderCell,
  // },
];



// WEBPACK FOOTER //
// ./src/containers/Markets/components/MarketsTable/components/MarketsTableComponent/columns.js